import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class PaymentPlanService {
  constructor(private http: HttpClientService) {}

  planSimulation(account_id: number | string, modifications, contributions, saved_version = false): Observable<any> {
    let options = {
      modifications,
      contributions,
      saved_version,
    };
    return this.http
      .post("/api/accounts/" + account_id + "/payment_plan/simulation", options)
      .pipe(tap((_) => console.log("PaymentsService.postPlanSimulation: Ok")));
  }

  planSimulationAnticipatedPayments(account_id: number | string, contributions): Observable<any> {
    let options = {
      contributions,
    };
    return this.http
      .post(`/api/accounts/${account_id}/payment_plan/simulation_anticipated_payments`, options)
      .pipe(tap((_) => console.log("PaymentsService.planSimulationAnticipatedPayments: Ok")));
  }

  anticipatedMaximumAndMinimum(account_id: number | string, contributions): Observable<any> {
    let options = {
      contributions,
    };
    return this.http
      .post(`/api/accounts/${account_id}/payment_plan/anticipated_maximum_and_minimum`, options)
      .pipe(tap((_) => console.log("PaymentsService.anticipatedMaximumAndMinimum: Ok")));
  }

  planSimulationPDF(account_id: number | string, modifications, contributions): Observable<any> {
    let options = {
      modifications,
      contributions,
    };
    return this.http
      .post("/api/accounts/" + account_id + "/payment_plan/simulation_pdf", options, { responseType: "blob" as "json" })
      .pipe(tap((_) => console.log("PaymentsService.postPlanSimulationPDF: Ok")));
  }

  public saveContributionsAndModifications(
    account_id,
    modifications,
    contributions,
    modification_ids_to_delete,
    contribution_ids_to_delete
  ): Observable<any> {
    let options = {
      modifications,
      contributions,
      modification_ids_to_delete,
      contribution_ids_to_delete,
    };
    return this.http
      .post("/api/accounts/" + account_id + "/payment_plan/save_contributions_and_modifications", options)
      .pipe(tap((_) => console.log("PaymentsService.saveContributionsAndModifications: Ok.")));
  }

  public listPaymentsRowsPending(account_id): Observable<any> {
    return this.http
      .get(`/api/accounts/${account_id}/payment_plan/list_payments_rows_pending`)
      .pipe(tap((_) => console.log("PaymentsService.listPaymentsRowsPending: Ok")));
  }

  public advanceRentRows(account_id): Observable<any> {
    return this.http
      .get(`/api/accounts/${account_id}/payment_plan/advance_rent_rows`)
      .pipe(tap((_) => console.log("PaymentsService.advanceRentRows: Ok")));
  }

  public accountStatementPdf(account_id: number | string, date): Observable<any> {
    let options = {
      date,
    };
    return this.http
      .post(`/api/accounts/${account_id}/payment_plan/account_statement_pdf`, options, {
        responseType: "blob" as "json",
      })
      .pipe(tap((_) => console.log("PaymentsService.accountStatementPdf: Ok")));
  }

  public modificationRequest(modification_id: number, request): Observable<any> {
    return this.http
      .post(`/api/payment_plan_modification/${modification_id}/modification_request`, request)
      .pipe(tap((_) => console.log("PaymentsService.modificationRequest: Ok")));
  }
}
